<template>
  <v-tooltip :disabled="disabled" bottom>
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on" :class="classList">
        <template v-if="infoIcon">
          <v-icon
            v-bind="attrs"
            v-on="on"
            color="info"
            :small="smallIcon"
          >mdi-information</v-icon>
        </template>
        <template v-else>
          <slot></slot>
        </template>
      </div>
    </template>
    <div :style="{ maxWidth: maxWidth }">{{ tooltip }}</div>
  </v-tooltip>
</template>

<script>
export default {
  name: 'SimpleTooltip',
  props: {
    tooltip: String,
    infoIcon: Boolean,
    smallIcon: Boolean,
    disabled: Boolean,
    classList: {
      type: [String, Array, Object],
      default: () => ''
    },
    maxWidth: {
      type: String,
      default: '600px'
    }
  }
}
</script>
